import { emphasize, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => {
	return {
		root: {
			overflow: 'hidden',
		},
		container: {
			justifyContent: 'center',
		},

		barColorPrimary: {
			backgroundColor: emphasize(theme.palette.primary.main, 0.5),
		},
	}
})

export default useStyles
